var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledSearchResultLink, StyledSearchResultMeta, } from "./SearchList.styled";
import { formatAddress } from "@rentiohq/shared-frontend/dist/utils/address.utils";
export var SearchItemApplication = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, linkHandler = _a.linkHandler, searchValue = _a.searchValue;
    return (_jsx(_Fragment, { children: data.slice(0, 10).map(function (item, index) {
            var link = "/properties/".concat(item.property.id, "/applications");
            return (_jsxs(StyledSearchResultLink, __assign({ to: link, onClick: linkHandler }, { children: [_jsx("div", { children: item.contacts
                            .map(function (contact) { return "".concat(contact.firstname, " ").concat(contact.lastname); })
                            .join(", ") }), _jsx(StyledSearchResultMeta, { children: formatAddress(item.property) })] }), "property".concat(index, "/applications")));
        }) }));
};
